module.exports = __webpack_public_path__ + "static/media/viewwebsite.3d49dd70.svg";